import React from 'react'
import Header from '@insight/toolkit-react/lib/Header/Header'

import Cart from '../IAHeaderTop/Cart'
import AccountMenuButton from './AccountMenuButton'
import { ENABLE_NIA } from '../../api/common/constants'

export default function MobileNav({ showOnlyCart = false, setIsOpen }) {
  const handleClick = () => {
    setIsOpen(true)
  }
  const enable_NIA = window?.flags && window?.flags[ENABLE_NIA]

  return (
    <Header.Nav.Mobile>
      {enable_NIA && (<Header.Nav.Mobile.Item
        icon="NIA"
        target={'_blank'}
        onClick={handleClick}
        className="c-header-main-nav__mobile-nia"
      >
        Nia
      </Header.Nav.Mobile.Item>)}
      {!showOnlyCart ? <AccountMenuButton />:null}
      <Cart isMobile />
      {!showOnlyCart ? <Header.Nav.Mobile.Search />:null}
      <Header.Nav.Mobile.Hamburger activates="flyout1" />
    </Header.Nav.Mobile>
  )
}

MobileNav.propTypes = {}
